module.exports = __webpack_public_path__ + "static/img/news65_7.df7c4eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/Information/news65/news65_7.png
// module id = Jn28
// module chunks = 0